import { memo } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Step from "./step";
import SearchPreview from "../../../assets/Images/search-preview.png";

const PlaceHolder = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "16px",
        backgroundColor: theme.palette.mode === "dark" ? "#21262C" : "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        gap: 2,
        padding: "24px",
        border: "1px solid #D8E3FB",
      }}
    >
      <img src={SearchPreview} alt="" width={192} height={224} />
      <Typography
        variant="h2"
        sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
      >
        Sẵn sàng định giá xe của bạn
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
      >
        Vui lòng nhập thông tin xe ở cột bên trái và nhấn{" "}
        <span style={{ color: "#203FB8" }}>"Tra cứu"</span> để bắt đầu quy trình
        định giá AI.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          width: "100%",
          justifyContent: "space-around",
        }}
      >
        <Step
          number={1}
          name="Nhập thông tin"
          descrip="Điền đầy đủ thông số kỹ thuật hoặc tải lên ảnh đăng kiểm."
        />
        <ArrowForwardIcon
          sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
        />
        <Step
          number={2}
          name="AI phân tích"
          descrip="Hệ thống xử lý dữ liệu và so sánh với thị trường theo thời gian thực."
        />
        <ArrowForwardIcon
          sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
        />
        <Step
          number={3}
          name="Nhận kết quả"
          descrip="Nhận báo cáo định giá chi tiết và thông tin thị trường chuyên sâu."
        />
      </Box>
    </Box>
  );
};

export default memo(PlaceHolder);
